import { DateTime } from 'luxon';

// ESTANDARIZAR FUNCIONES DE FLECHA O UTILIZAR LIBRERIA MOMENTX
const days = [
   {
      "day": 0,
      "codeEn": "sun",
      "en": "Sunday.",
      "es": "Domingo",
      "codeEs": "Dom"
   },
   {
      "day": 1,
      "codeEn": "mon",
      "en": "Monday.",
      "es": "Lunes",
      "codeEs": "Lun"
   },
   {
      "day": 2,
      "codeEn": "tue",
      "en": "Tuesday.",
      "es": "Martes",
      "codeEs": "Mar"
   },
   {
      "day": 3,
      "codeEn": "wed",
      "en": "Wednesday.",
      "es": "Miércoles",
      "codeEs": "Mie"
   },
   {
      "day": 4,
      "codeEn": "thu",
      "en": "Thursday.",
      "es": "Jueves",
      "codeEs": "Jue"
   },
   {
      "day": 5,
      "codeEn": "fri",
      "en": "Friday.",
      "es": "Viernes",
      "codeEs": "Vie"

   },
   {
      "day": 6,
      "codeEn": "sat",
      "en": "Saturday.",
      "es": "Sábado",
      "codeEs": "Sab"
   }
]


export const mounths = [
   {
       month: 0,
       en:  'January',
       codeEn: 'Jan',
       es: 'Enero',
       codeEs: 'Ene'
   },
   {
       month: 1,
       en: 'February' ,
       codeEn: 'Jan' ,
       es: 'Febrero',
       codeEs: 'Feb'
   },
   {
       month: 2,
       en:  'March'  ,
       codeEn: 'Mar' ,
       es: 'Marzo',
       codeEs: 'Mar'
   },
   {
       month: 3,
       en:  'April' ,
       codeEn:  'Apr' ,
       es: 'Abril',
       codeEs: 'Abr'
   },
   {
       month: 4,
       en:  'May' ,
       codeEn: 'May' ,
       es: 'Mayo',
       codeEs: 'May'
   },
   {
       month: 5,
       en:  'June' ,
       codeEn:  'June' ,
       es: 'Junio',
       codeEs: 'Jun'
   },
   {
       month: 6,
       en: 'July' ,
       codeEn: 'July',
       es: 'Julio',
       codeEs: 'Jul'
   },
   {
       month: 7,
       en:  'August' ,
       codeEn:  'Aug',
       es: 'Agosto',
       codeEs: 'Ago'
   },
   {
       month: 8,
       en: 'September' ,
       codeEn: 'Sept' ,
       es: 'Septiembre',
       codeEs: 'Sep'
   },
   {
       month: 9,
       en: 'October' ,
       codeEn: 'Oct',
       es: 'Octubre',
       codeEs: 'Oct'
   },
   {
       month: 10,
       en:  'November',
       codeEn: 'Nov',
       es: 'Noviembre',
       codeEs: 'Nov'
   },
   {
       month: 11,
       en:  'December',
       codeEn: 'Dec',
       es: 'Diciembre',
       codeEs: 'Dic'
   },
]


export const getDaysName = (date, language) => {
   const fecha = new Date(date);
   const day = fecha.getDay();
   return language === 'en' ? days[day].en : days[day].es
}

export const getMonthNames = (month, language) => {
   return language === 'en' ? mounths[month]?.en : mounths[month]?.es
}

export const getFechaFormatoSmall = (date) => {
   const d = new Date(date);
   return days.filter(e => e.day === d.getDay())[0].codeEs + ', ' + d.getDate() + ' ' + mounths.filter(m => m.month === d.getMonth())[0].codeEs + ', ' + d.getFullYear()
}
export const getFechaFormatoLarge = (date) => {
   const d = new Date(date);
   return days.filter(e => e.day === d.getDay())[0].es + ', ' + d.getDate() + ' ' + mounths.filter(m => m.month === d.getMonth())[0].es + ' de ' + d.getFullYear()
}

export const getDateTimeString = (date) => {
   const d = new Date(date.getTime() + 6 * 60 * 60 * 1000);
   return d.toLocaleString('ES-HN');
}
export const getDateTimeString2 = (date) => {
   const d = new Date(date.getTime() + 6 * 60 * 60 * 1000);
   return d.toLocaleString('ES-HN', { hour12: true });
}

export const getDateTimeStringUS = (date) => {
   const d = new Date(date.getTime() + 24 * 60 * 60 * 1000);
   return d.toLocaleString('ES-US', { hour12: false }).replace(',', '');
}
export const getLocalDateTimeString = (date) => {
   const d = new Date(date);
   return d.toLocaleString('ES-US', { hour12: false }).toUpperCase();
}
export const getLocalDateString1  = (date) => {
   const d = new Date(date.getTime());
   return d.toLocaleDateString('ES-HN');
}
export const getDateTimeSQL = (date) => {
   const d = new Date(date.getTime() - 6 * 60 * 60 * 1000);
   return d.toLocaleString('EN-US', { hour12: false }).replace(',', '');
}
export const getDateTimeSQL2 = (date) => {
   const d = new Date(date.getTime() - 6 * 60 * 60 * 1000);
   return d.toLocaleString('ES-HN').replace(',', '');
}
export const getDateTimeSQL3 = (date) => {
   const d = new Date(date.getTime());
   return d.toLocaleString('EN-US', { hour12: false }).replace(',', '');
}
export const getDateTimeSQL4 = (date) => {
   const d = new Date(date.getTime());
   return d.toLocaleString('EN-US', { hour12: true }).replace(',', '');
}
export const getDateTimeSQL5 = (date) => {
   const d = new Date(date.getTime());
   return d.toLocaleString('ES-US', { hour12: true }).replace(',', '').replace('a.','A').replace('m.', 'M');
}
export const setDateTimeSQL = (date) => {
   const d = new Date(date);
   return d.toLocaleString('EN-US').replace(',', '');
}

export const setDateTimeSQLH = (date) => {
   const d = new Date(date);
   return d.toLocaleDateString('EN-US')
   
}

export const getDate = (date) => {
   const d = new Date(date.getTime() + 6 * 60 * 60 * 1000);
   return d;
}

export const getTime = (date) => {
   const d = new Date(date.getTime() + 6 * 60 * 60 * 1000);
   return d.toTimeString('EN-US');
}

export const getHora = (date) => {
   const d = new Date(date.getTime());
   return d.toTimeString('EN-US');
}


export const getLocalDateString = (date) => {
   const d = new Date(date.getTime() + 6 * 60 * 60 * 1000);
   return d.toLocaleDateString('ES-HN');
}
export const getDateProduccionSQL = (date) => {
   const d1 = new Date(date[0].getTime() - (6 * 60 * 60 * 1000) + (24 * 60 * 60 * 1000));
   let d2 = new Date()
   if(date[1]){
      d2 = new Date(date[1].getTime() - (6 * 60 * 60 * 1000) + (48 * 60 * 60 * 1000));
   }else{
      d2 = new Date(date[0].getTime() - (6 * 60 * 60 * 1000) + (48 * 60 * 60 * 1000));
   }
   return [
      d1.toLocaleDateString('EN-US') + ' 7:00:00 AM',
      d2.toLocaleDateString('EN-US') + ' 6:59:59 AM'
   ]
}

export const getDateProduction = (date) => {
   const d1 = new Date(date[0]);
   const d2 = new Date(date[1].getTime() + (24 * 60 * 60 * 1000));
   return [
      d1.toLocaleDateString('EN-US') + ' 7:00:00 AM',
      d2.toLocaleDateString('EN-US') + ' 6:59:59 AM'
   ]
}

export const getTiempoActivo = (Creada, Vencimiento) => {

   // asignar el valor de las unidades en milisegundos
   let msecPerMinute = 1000 * 60;
   let msecPerHour = msecPerMinute * 60;


   // Obtener la diferencia en milisegundos
   let interval = Vencimiento.getTime() - Creada.getTime();


   // Calcular las horas , minutos y segundos
   let hours = Math.floor(interval / msecPerHour);
   interval = interval - (hours * msecPerHour);

   let minutes = Math.floor(interval / msecPerMinute);
   interval = interval - (minutes * msecPerMinute);

   let seconds = Math.floor(interval / 1000);

   let dias = 0;
   if(hours >= 24) {
      dias = Math.floor(hours / 24);
      hours = hours - (dias * 24);
      return dias + ' dia, ' +  agregarCeroSiEsNecesario(hours) + ":" + agregarCeroSiEsNecesario(minutes) + ":" + agregarCeroSiEsNecesario(seconds)
   }else{
      return agregarCeroSiEsNecesario(hours) + ":" + agregarCeroSiEsNecesario(minutes) + ":" + agregarCeroSiEsNecesario(seconds)
   }

}

const agregarCeroSiEsNecesario = valor => {
   if (valor < 10) {
      return "0" + valor;
   } else {
      return "" + valor;
   }
}


export const formatDate =(date) => {
   const day = date.getDate().toString().padStart(2, '0');
   const month = (date.getMonth() + 1).toString().padStart(2, '0');
   const year = date.getFullYear().toString();
   let hours = date.getHours();
   const amOrPm = hours >= 12 ? 'PM' : 'AM';
   hours = hours % 12;
   hours = hours ? hours : 12;
   const minutes = date.getMinutes().toString().padStart(2, '0');
   const seconds = date.getSeconds().toString().padStart(2, '0');
   const time = hours.toString().padStart(2, '0') + ':' + minutes + ':' + seconds + ' ' + amOrPm;
   return `${day}/${month}/${year} ${time}`;
 }

export const formatFecha =(d) => {
   const date = new Date(d);
   const day = date.getDate().toString().padStart(2, '0');
   const month = (date.getMonth() + 1).toString().padStart(2, '0');
   const year = date.getFullYear().toString();
   let hours = date.getHours();
   hours = hours % 12;
   hours = hours ? hours : 12;

   // console.log(`${day}/${month}/${year} ${time}`);
   return `${day}/${month}/${year}`;
}

export const getDateStringAbr = (date) => {
   const fecha = new Date(date? date : new Date());
   const day = fecha.getDate().toString().padStart(2, '0');
   return `${day}/ ${getMonthNames((new Date(fecha)).getMonth(), 'es')}/ ${(new Date(fecha)).getFullYear()}`;
}

export const getFechaPartida = (dates, days = [3, 2]) => {
   let dInicio
   let dFinal
   if (days[0] === 0) {
       dInicio = new Date(dates[0])
   } else {
       dInicio = new Date(dates[0] - 1000 * 60 * 60 * 24 * days[0])
   }

   if (days[1] === 0) {
       dFinal = new Date(dates[1].getTime() + 1000 * 60 * 60 * 24)
   } else {

       dFinal = new Date(dates[1].getTime() - 1000 * 60 * 60 * 24 * days[1])
   }


   return [
       dInicio.toLocaleDateString('EN-US') + ' 7:00:00 AM',
       dFinal.toLocaleDateString('EN-US') + ' 6:59:59 AM'
   ]
}

export const formatFechaEN =(d) => {
   const date = new Date(d);
   const day = date.getDate().toString().padStart(2, '0');
   const month = (date.getMonth() + 1).toString().padStart(2, '0');
   const year = date.getFullYear().toString();
   let hours = date.getHours();
   hours = hours % 12;
   hours = hours ? hours : 12;

   // console.log(`${day}/${month}/${year} ${time}`);
   return `${month}/${day}/${year}`;
 }

 export const agregarDias = (date, days) => {
   let d = new Date(date)

   return new Date(d.getTime() + 1000 * 60 * 60 * 24 * days)
}

export const restarDias = (date, days) => {
   let d = new Date(date)

   return new Date(d.getTime() - 1000 * 60 * 60 * 24 * days)
}

export const getDateString2 = (date) => {
   const d = DateTime.fromJSDate(new Date(date)).setLocale('es-HN');
   return d.toFormat('MM/dd/yyyy')
}

export const horaASegundos = (hora) => {
   if(hora){
      const [h, m, s] = hora?.split(":")?.map(Number);
      return h * 3600 + m * 60 + s;
   }else{
      return null
   }
};

export const diferenciaHoras = (tempoHoras, incluirSegundos = true) => {
   let diferenciaFinal = null
   if(tempoHoras){
      const diferenciaSegundos = horaASegundos(tempoHoras[0]) - horaASegundos(tempoHoras[1]);
      const horas = Math.floor(diferenciaSegundos / 3600);
      const minutos = Math.floor((diferenciaSegundos % 3600) / 60);
      const segundos = diferenciaSegundos % 60;

      diferenciaFinal = `${horas > 0 ? horas + ' horas ' : ''}${minutos} minutos  ${incluirSegundos ? segundos + ' segundos' : ''} `;
   }

   return diferenciaFinal

}